export default {"src":"/_next/static/media/quad_bikes.80596a8c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};